import { useQuery } from 'react-query';
import { CUSTOMER_SERVICE_REQUESTS } from '../../constants/reactQuery.keys';
import PatientView from '../../services/PatientView';

/* Get customer service requests
 * Params: id (customer id)
 */
export const useCustomerServiceRequests = (id: number) => {
  const response = useQuery([CUSTOMER_SERVICE_REQUESTS, id], () => PatientView.getPatientServiceRequests(id), {
    refetchOnWindowFocus: false,
    keepPreviousData: false,
  });

  return {
    ...response,
    data: response.data || [],
  };
};
